import styled from "styled-components"
import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useState } from "react"

import { useContent } from "../../shared/hooks"

const PADDING_IN_VW = 3
const PADDED_WIDTH_FACTOR = (100 - 2 * PADDING_IN_VW) / 100

const Container = styled(motion.div)`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 56px;
  padding: 0 ${PADDING_IN_VW}vw;
  background: rgba(54, 54, 54, 0.44);
  display: flex;
  align-items: center;
  justify-content: center;
`

const Line = styled(motion.div)`
  height: 6px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
`

const Poi = styled.img`
  position: absolute;
  left: ${({ posXInPercent }) => posXInPercent}vw;
  transform: translateX(-50%);
`

const Marker = styled.img.attrs(({ posXInPercent }) => ({
  style: {
    left: `${posXInPercent}vw`,
  },
}))`
  position: absolute;
  transform: translateX(-50%);
`

const animations = {
  variants: {
    visible: {
      opacity: 1,
      y: 0,
    },
    hidden: {
      opacity: 0,
      y: 200,
    },
  },
  transition: { duration: 0.8 },
  initial: "hidden",
  animate: "visible",
  exit: "hidden",
}

const Minimap = ({ isVisible, parallaxContainerRef, windowWidth, sceneWidth }) => {
  const pois = useContent({ path: "pois" })
  const [scrolledXPercentage, setScrolledXPercentage] = useState(0)

  useEffect(() => {
    const parallaxContainer = parallaxContainerRef.current
    const updateScroll = () => {
      setScrolledXPercentage(
        (parallaxContainer.current / (windowWidth * sceneWidth - windowWidth)) * 100
      )
    }
    parallaxContainer.container.current.addEventListener("scroll", updateScroll)
    return () => {
      parallaxContainer.container.current.removeEventListener("scroll", updateScroll)
    }
  }, [parallaxContainerRef, sceneWidth, windowWidth])

  return (
    <AnimatePresence>
      {isVisible && (
        <Container key={"Minimap"} {...animations}>
          <Line />
          {Object.values(pois).map((poi) => (
            <Poi
              key={poi.id}
              src={"../assets/images/minimapPoi.png"}
              posXInPercent={getPaddedPosX(poi.position * 100)}
            />
          ))}
          <Marker
            src={"../assets/images/minimapMarker.png"}
            posXInPercent={getPaddedPosX(scrolledXPercentage)}
            transition={{ duration: 0 }}
          />
        </Container>
      )}
    </AnimatePresence>
  )
}

function getPaddedPosX(posXInPercent) {
  return posXInPercent * PADDED_WIDTH_FACTOR + PADDING_IN_VW
}

export default Minimap
